import React, { useState } from 'react';
import LIBRARY from './library.json';

// every title, with the folder it lives in
const ALL = LIBRARY.flatMap((f) => f.items.map((i) => ({ ...i, folder: f.name })));

// the shelves you can step through: every shelf at once, then each folder
const SHELVES = [{ id: '', name: 'any shelf' }, ...LIBRARY.map((f) => ({ id: f.id, name: f.name }))];

// the titles in a folder ('' means every folder)
export const titlesIn = (folderId) => (folderId ? LIBRARY.find((f) => f.id === folderId).items.map((i) => ({ ...i, folder: LIBRARY.find((f) => f.id === folderId).name })) : ALL);

// a random title other than `current`
export function pickTitle(titles, current, rng = Math.random) {
  const pool = titles.filter((t) => !current || t.id !== current.id);
  return pool.length ? pool[Math.floor(rng() * pool.length)] : titles[0] || null;
}

function MediaBrowser() {
  const [shelfAt, setShelfAt] = useState(0);
  const folderId = SHELVES[shelfAt].id;
  const shelfName = SHELVES[shelfAt].name;
  const [item, setItem] = useState(() => pickTitle(ALL, null));
  const titles = titlesIn(folderId);

  // wraps around at both ends
  const stepShelf = (delta) => {
    const next = (shelfAt + delta + SHELVES.length) % SHELVES.length;
    setShelfAt(next);
    setItem(pickTitle(titlesIn(SHELVES[next].id), null));
  };

  return (
    <div className="fm-pick">
      <div className="fm-stepper" role="group" aria-label="Shelf">
        <button type="button" className="ms-btn ms-btn-small" onClick={() => stepShelf(-1)} aria-label="Previous shelf">◀</button>
        <span className="fm-stepper-name" aria-live="polite">{shelfName} <small>{shelfAt + 1}/{SHELVES.length}</small></span>
        <button type="button" className="ms-btn ms-btn-small" onClick={() => stepShelf(1)} aria-label="Next shelf">▶</button>
      </div>
      <h3 className="fm-pick-title"><span className="fm-clamp">{item.title}</span></h3>
      <div className="fm-pick-note fm-scroll" tabIndex={0} aria-label={`About ${item.title}`}>
        <p>{item.blurb || 'No description saved for this one.'}</p>
      </div>
      <div className="fm-pick-actions">
        <button type="button" className="ms-btn fm-pick-main" onClick={() => setItem(pickTitle(titles, item))}>🎲 another</button>
        {item.url
          ? <a className="ms-btn fm-pick-main" href={item.url} target="_blank" rel="noopener noreferrer">{item.source} ↗</a>
          : <span className="ms-btn fm-pick-main" aria-disabled="true">no link</span>}
      </div>
    </div>
  );
}

export default MediaBrowser;
